/**
 * `/v1/users` nao devolve so usuarios reais.
 *
 * `user_service.list_users` anexa os cadastros pendentes de aprovacao no fim
 * da lista como linhas virtuais: **`id: null`**, `type: 'pending_registration'`
 * e o id real em `registration_id`. E a mesma armadilha que
 * `components/admin/users/rowKey.ts` ja resolve para a tabela de usuarios.
 *
 * Qualquer seletor (`Select`/`MultiSelect`) que mapeie essa lista para
 * `{ value: String(u.id) }` transforma cada pendente numa opcao de valor
 * `"null"`. Com **dois** pendentes o Mantine lanca
 * `Duplicate options are not supported. Option with value "null" was provided
 * more than once` e derruba a arvore — `validateOptions` roda sem guarda de
 * ambiente, entao quebra em producao tambem (incidente de 24/08/2026 na tela
 * Organizacao > Colaboradores). Com **um** so, a opcao fantasma fica
 * selecionavel e o POST sai com `Number('null')` = `NaN`.
 *
 * Use `selectableUsers` sempre que a lista de `/v1/users` alimentar um seletor.
 */

/** Linha de `/v1/users`: usuario real OU cadastro pendente (`id: null`). */
export type MixedUserRow = {
  id: number | null
  type?: string
  status?: string
}

export function isPendingRegistration(row: Pick<MixedUserRow, 'type' | 'status'>): boolean {
  return row.type === 'pending_registration' || row.status === 'pending_approval'
}

/**
 * So usuarios reais — o que um seletor pode oferecer.
 *
 * O `id != null` nao e redundante com o predicado de pendente: e ele que
 * garante o invariante que o Mantine cobra (`value` unico e nao-"null") mesmo
 * se o backend passar a anexar outro tipo de linha virtual.
 */
export function selectableUsers<T extends MixedUserRow>(rows: T[]): (T & { id: number })[] {
  return rows.filter((r): r is T & { id: number } => r.id != null && !isPendingRegistration(r))
}
